module.exports = __webpack_public_path__ + "img/t-shirt-4.d267a1da.png";